import { createSlice } from "@reduxjs/toolkit";

export const oauthApi = createSlice({
  name: "oauth",
  initialState: {},
  reducers: {},
});

export default oauthApi.reducer;
